import React from 'react';
import Card from '../../components/ui/Card';
import { BANCOS_CONFIG } from '../../constants/bancos';
import { formatarMoeda, formatarCompacto, formatarPercentual } from '../../utils/formatters';

export default function BankCard({ sim, isBest, isSelected, onClick }) {
  const config = BANCOS_CONFIG.find(
    (b) => sim.banco === b.banco || sim.nomeBanco?.includes(b.banco)
  );
  const cor = config?.cor || '#3B82F6';
  const sigla = config?.sigla || sim.banco?.substring(0, 3).toUpperCase();

  return (
    <Card
      onClick={onClick}
      style={{
        cursor: 'pointer',
        position: 'relative',
        border: isSelected ? '2px solid var(--accent)' : '1px solid var(--border)',
        background: isSelected ? 'rgba(0,214,143,0.02)' : 'var(--white)',
      }}
    >
      {isBest && (
        <span
          style={{
            position: 'absolute',
            top: -10,
            right: 12,
            background: 'var(--accent)',
            color: 'var(--primary)',
            fontSize: '0.65rem',
            fontWeight: 700,
            padding: '3px 10px',
            borderRadius: 100,
          }}
        >
          Melhor opção
        </span>
      )}

      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
        <div
          style={{
            width: 38,
            height: 38,
            borderRadius: 8,
            background: cor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            fontWeight: 700,
            fontSize: '0.7rem',
            flexShrink: 0,
          }}
        >
          {sigla}
        </div>
        <div>
          <div style={{ fontWeight: 700, fontSize: '0.95rem' }}>{sim.nomeBanco || sim.banco}</div>
          <div style={{ fontSize: '0.78rem', color: 'var(--gold)', fontWeight: 600 }}>
            {formatarPercentual(sim.taxaJurosAnual)} a.a.
          </div>
        </div>
      </div>

      <div style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: 2 }}>
        {formatarMoeda(sim.informacoes.primeiraParcela)}
      </div>
      <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginBottom: 16 }}>1ª parcela</div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
        <div>
          <div style={{ fontSize: '0.68rem', color: 'var(--text-muted)' }}>Total Juros</div>
          <div style={{ fontSize: '0.85rem', fontWeight: 600, color: 'var(--rose)' }}>
            {formatarCompacto(sim.totais.totalJuros)}
          </div>
        </div>
        <div>
          <div style={{ fontSize: '0.68rem', color: 'var(--text-muted)' }}>Total Pagar</div>
          <div style={{ fontSize: '0.85rem', fontWeight: 600 }}>
            {formatarCompacto(sim.totais.totalAPagar)}
          </div>
        </div>
      </div>
    </Card>
  );
}